if (!customElements.get('ss-lazy-video')) {
  customElements.define('ss-lazy-video', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('button')?.addEventListener('click', () => {
        this.hydrate();
        this.start(true);
      }, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible && !this.reducedMotion) this.hydrate();
        if (!this.video || !this.hasAttribute('data-autoplay')) return;
        if (this.visible && !this.reducedMotion) this.start();
        else this.video.pause();
      }, {threshold: 0.05});
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video?.pause();
        else if (this.visible && this.hasAttribute('data-autoplay') && !this.reducedMotion) this.start();
      }, options);
    }
    start(userInitiated = false) {
      if (!this.video || document.hidden) return;
      if (!userInitiated && (!this.visible || this.reducedMotion)) return;
      this.video.play().catch(() => {});
    }
    hydrate() {
      if (this.video) return;
      const template = this.querySelector('template');
      const video = template?.content.querySelector('video');
      if (!video) return;
      this.video = video;
      const autoplay = this.hasAttribute('data-autoplay');
      if (autoplay) {
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = !this.reducedMotion;
        video.loop = true;
        video.playsInline = true;
        video.controls = false;
        video.removeAttribute('controls');
        ['muted', 'loop', 'playsinline', 'webkit-playsinline'].forEach(name => video.setAttribute(name, ''));
      }
      video.preload = 'metadata';
      const options = {signal: this.controller.signal};
      video.addEventListener('playing', () => this.querySelector('button')?.remove(), options);
      if (autoplay) {
        ['loadeddata', 'canplay'].forEach(event => video.addEventListener(event, () => this.start(), options));
      }
      template.replaceWith(video);
      video.load();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}
